// /frontend/src/pages/ShippingPage.jsx
import React from 'react';
import Layout from '../components/layout/Layout';
import { Link } from 'react-router-dom';

const ShippingPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Shipping Information</h1>
        
        <div className="prose prose-lg max-w-none">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8">
            <p className="text-lg text-gray-800">
              Please review our <Link to="/terms" className="text-teal-700 hover:text-teal-900 font-medium">Terms of Service</Link> for important information about lead times and installation requirements.
            </p>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Shipping Areas</h2>
          <p className="mb-6">
            Henderson Design Group currently ships to all Hawaiian islands. For mainland U.S. or international shipping inquiries, please contact our customer service team for availability and rates.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Delivery Timeline</h2>
          <p className="mb-6">
            Our estimated delivery timelines are as follows:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2"><strong>In-stock items:</strong> 2-4 weeks for delivery</li>
            <li className="mb-2"><strong>Made-to-order items:</strong> 8-12 weeks plus delivery time</li>
            <li className="mb-2"><strong>Design projects:</strong> Timeline will be provided in your project proposal</li>
            <li className="mb-2"><strong>Furniture Packages:</strong> 8-12 weeks depending on item availability</li>
          </ul>
          <p className="mb-6">
            Please note that these are estimated timeframes and may vary depending on product availability, customization options, and shipping destination. You will receive a more specific delivery timeline when your order is confirmed.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Shipping Costs</h2>
          <p className="mb-6">
            Shipping costs are calculated based on the following factors:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Order total</li>
            <li className="mb-2">Delivery location</li>
            <li className="mb-2">Size and weight of items</li>
            <li className="mb-2">Special handling requirements</li>
          </ul>
          <p className="mb-6">
            Exact shipping costs will be calculated at checkout or included in your custom proposal. For Furniture Packages, shipping is included in the package price for standard delivery within Oahu.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Delivery & Installation</h2>
          <p className="mb-6">
            Our white glove delivery service includes:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Delivery to your room of choice</li>
            <li className="mb-2">Basic assembly of furniture items</li>
            <li className="mb-2">Removal of packaging materials</li>
            <li className="mb-2">Placement according to your specifications or design plan</li>
          </ul>
          <p className="mb-6">
            For Design projects, our team will coordinate with you for a seamless installation process.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Tracking Your Order</h2>
          <p className="mb-6">
            Once your order has been processed and shipped, you will receive tracking information via email. For custom orders and Furniture Packages, our team will provide regular updates on the status of your order and coordinate delivery directly with you.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Shipping Delays</h2>
          <p className="mb-6">
            While we strive to meet all estimated delivery dates, occasional delays may occur due to manufacturing timelines, shipping carrier delays, or unforeseen circumstances. We will communicate any significant delays promptly and provide updated delivery estimates.
          </p>
          
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-10">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Questions About Shipping?</h3>
            <p className="mb-4">
              Our customer service team is available to assist you with any shipping inquiries. Contact us at <a href="tel:+18083158782" className="text-teal-700 hover:text-teal-900">808.315.8782</a> or <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a>.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ShippingPage;